var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-v2"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"col__box"},[_c('h1',[_vm._v("Chính sách quyền riêng tư")])])])])
}]

export { render, staticRenderFns }